import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'mx-a f-col items-center gap-4 md:w-max',
    label: 'body-3 c-brand-1'
  }
} satisfies RecursivePartial<ProductConfig['pagination']>
